export function createOid(type) {
  let oid = window.location.pathname.replaceAll('/', '_').replaceAll('-', '_');
  if (type === 'ec') {
    return 'btn' + oid;
  } else if (type === 'ev') {
    return 'btn' + oid;
  }
  return oid === '_' ? 'page_index' : 'page' + oid;
}
